import { render } from "./SimpleLayout.vue?vue&type=template&id=514022bc"
import script from "./SimpleLayout.vue?vue&type=script&lang=js"
export * from "./SimpleLayout.vue?vue&type=script&lang=js"

import "./SimpleLayout.vue?vue&type=style&index=0&id=514022bc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__